export default __webpack_public_path__ + "static/media/custodyProcess.56940141.png";